import { PersonalizationClient } from '@atc/personalization-client';
import { Duck } from '@atc/modular-redux';

// Selectors
import selectors from './recentSearchDuckSelectors';
import reducer from './recentSearchDuckReducer';
import creators from './recentSearchDuckCreators/index.js';
const defaultState = {
  inventorySearches: [],
  // [{url: string, title: string, criteriaSummary: string, carCount: number, listedSinceLastSearchCount: number}, ...]
  recentlySearchedWithListings: []
};

// export personalization only for testing
// eslint-disable-next-line import/no-mutable-exports
export let personalization;
export default function recentSearchDuckCreator(_temp) {
  let {
    namespace = '',
    store = 'recentSearch',
    storePath,
    initialState = {},
    env = 'qa',
    ...rest
  } = _temp === void 0 ? {} : _temp;
  personalization = new PersonalizationClient({
    env
  });
  return new Duck({
    ...rest,
    namespace,
    store,
    storePath,
    initialState: {
      ...defaultState,
      ...initialState
    },
    consts: {},
    types: ['SET_RECENT_SEARCHES', 'SET_RECENT_SEARCHES_INVENTORY'],
    creators: duck => creators(duck, personalization),
    reducer,
    selectors: selectors()
  });
}